import axios from "axios";

console.log("REACT_APP_API_URL =", process.env.REACT_APP_API_URL);

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 15000,
    headers: {
        "Content-Type": "application/json",
    },
});

// Attach token
api.interceptors.request.use((config) => {

    const token = localStorage.getItem("access_token");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// Handle expired tokens
api.interceptors.response.use(

    (response) => response,

    (error) => {

        if (error.response?.status === 401) {

            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");

            // Prevent endless redirect
            if (window.location.pathname !== "/admin/login") {
                window.location.href = "/admin/login";
            }
        }

        return Promise.reject(error);
    }

);

export default api;